import { render, staticRenderFns } from "./BotaoEditar.vue?vue&type=template&id=9978c8e0&scoped=true"
import script from "./BotaoEditar.vue?vue&type=script&lang=js"
export * from "./BotaoEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9978c8e0",
  null
  
)

export default component.exports